import { useCallback, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { connect, useDispatch } from 'react-redux';
import cn from 'classnames';
import { useField } from 'react-final-form';
import { Dispatch } from 'redux';

import { IKnmUsername } from 'APIPackage/KnmModule/interfaces/IKnmUsername';
import { KnmPublishStatusesEnum } from 'APIPackage/KnmModule/enums/KnmPublishStatusesEnum';
import { IKnmStatus } from 'APIPackage/CatalogsModule/interfaces/IKnmStatus';
import {
  getUserRoleIsProsecutorOrSuperProsecutor,
  getUserRoleIsSupervisor,
} from 'AuthPackage/MainModule/selectors/authSelectors';
import { DATE_FORMAT_ISO_FNS, DATE_FORMAT_LONG_MINUTE_FNS } from 'CorePackage/MainModule/constants/dateFormats';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { ROUTE_KNM_LIST, ROUTE_PLAN_BY_ID } from 'CorePackage/MainModule/routes/routes';
import {
  getDictionaryKnoSupervisionStatus,
  getKnmData,
  getKnmDataCreated,
  getKnmDataCreatedBy,
  getKnmDataCreationDate,
  getKnmDataDeleted,
  getKnmDataErknmApproveApproved,
  getKnmDataErknmUntimelyBasic,
  getKnmDataErknmWebNotificationInfos,
  getKnmDataErpId,
  getKnmDataIsTest,
  getKnmDataPlanId,
  getKnmDataResigningRequired,
  getKnmDataUpdated,
  getKnmDataUpdatedBy,
  getKnmHasReasonsImpossibility,
  getKnmIsErknmStatusTypeCantBeCarryOut,
  getKnmIsErpStatusDeleted,
  getKnmIsErpStatusDisapproved,
  getKnmIsErpStatusNeedDoOverAgain,
  getKnmIsErpStatusSyspApprove,
  getKnmIsInitialData,
  getKnmPublishedStatus,
  getKnmStatus,
  getKnmStatusText,
  getKnmSystemType,
  getKnmDataMassCancel,
  getKnmIsErknmStatusTypeCanceled,
  getKnmDataMassDelete,
} from 'KnmPackage/MainModule/selectors/knmSelectors';
import { KnmSystemTypesEnum } from 'KnmPackage/MainModule/enums/KnmSystemTypesEnum';
import { exportKnmTypeEventFormNamesMap } from 'KnmPackage/MainModule/constants/exportKnmTypeEventFormNamesMap';
import { publishedStatusesCodesNamesMap } from 'NewsPackage/MainModule/constants/publishedStatuses';
import { formatDate, formatDateLocale, getFormatedClientTime } from 'CorePackage/MainModule/common/formatDate';
import { getNewMappedStatus } from 'KnmErpPackage/MainModule/common/getNewMappedStatus';
import { KnmErknmStatusCodesEnum } from 'APIPackage/CatalogsModule/enums/KnmErknmStatusCodesEnum';
import { KnmWebNotificationTypesEnum } from 'APIPackage/KnmModule/enums/KnmWebNotificationTypesEnum';
import { ApprovedTypesEnum } from 'APIPackage/KnmModule/enums/ApprovedTypesEnum';
import { IKnmWebNotificationInfo } from 'APIPackage/KnmModule/interfaces/IKnmWebNotificationInfo';
import { DictionaryStatusesEnum } from 'CorePackage/DictionariesModule/enums/DictionaryStatusesEnum';
import { IKnm } from 'APIPackage/KnmModule/interfaces/IKnm';
import { getAdminFetchSettings } from 'PersonalAccountPackage/AdminModule/selectors/adminSelectors';
import { IAdminSetting } from 'APIPackage/AdminModule/interfaces/IAdminSetting';
import { isLaterThanAdminSetting } from 'CorePackage/MainModule/validators/isLaterThanAdminSetting';
import { AdminSettingCodesEnum } from 'APIPackage/AdminModule/enums/AdminSettingCodesEnum';
import { convertInitialKnmDateToFormDate } from 'KnmPackage/MainModule/common/convertInitialKnmDateToFormDate';
import { knmDraftDelete } from 'KnmPackage/MainModule/actions/knmActions';
import { IKnmAttachment } from 'APIPackage/KnmModule/interfaces/IKnmAttachment';
import { PLAN_NO_SIGN_NOTIFICATION_ERROR } from 'CorePackage/MainModule/constants/notices';
import { IKnmPlan } from 'PlanListPackage/MainModule/interfaces/IKnmPlan';
import { getPlanSignedHistoryChanges } from 'PlanPackage/MainModule/selectors/planSelectors';
import { RootActions } from 'CorePackage/MainModule/types/RootActions';

import { getIsPublishAvailable } from '../common/getIsPublishAvailable';
import { ErrorsIcon } from './ErrorsIcon';
import { KnmHeaderButtons } from './KnmHeaderButtons';
import styles from './KnmHeader.module.scss';
import {
  getPlanListPlan,
  getPlanListPlanErknmStatus,
  getPlanSigned,
} from '../../../PlanListPackage/MainModule/selectors/planListSelectors';
import { ErknmPlanStatusesEnum } from '../../../APIPackage/PlanListModule/enums/ErknmPlanStatusesEnum';
import { IKnmForm } from '../../MainModule/interfaces/IKnmForm';
import { ErrorsIconForUntimelyBasic } from './ErrorsIconForUntimelyBasic';
import { ErknmStatusHint } from './ErknmStatusHint';
import { IKnmMassCancel } from '../../../APIPackage/KnmModule/interfaces/IKnmMassCancel';
import { IKnmMassDelete } from '../../../APIPackage/KnmModule/interfaces/IKnmMassDelete';
import { PmStatusHint } from './PmStatusHint';

interface IKnmHeaderProps {
  isPm?: boolean;
  clearDraftPassportData: () => void;
  values: IKnmForm;
}

interface IKnmHeaderStoreProps {
  isProsecutorOrSuperProsecutor: boolean | undefined;
  isSupervisor: boolean | undefined;
  publishedStatus: KnmPublishStatusesEnum | undefined;
  status: IKnmStatus | undefined;
  statusText: string | undefined;
  isErpStatusDeleted: boolean;
  isErpStatusDisapproved: boolean;
  isErpStatusSyspApprove: boolean;
  isErpStatusNeedDoOverAgain: boolean;
  untimelyBasic: boolean | null | undefined;
  isInitialData?: boolean;
  knmSystemType: KnmSystemTypesEnum | undefined;
  isReasonsImpossibility: boolean;
  knmData: IKnm | undefined;
  erpId: string | undefined;
  knmCreated: string | null | undefined;
  knmCreatedBy: IKnmUsername | undefined;
  knmCreationDate: string | null | undefined;
  isKnmDeleted: boolean | undefined;
  knmUpdated: string | null | undefined;
  knmUpdatedBy: IKnmUsername | undefined;
  planId: number | null | undefined;
  knmDataErknmApproveApproved: ApprovedTypesEnum | null | undefined;
  webNotificationInfos: IKnmWebNotificationInfo[] | null | undefined;
  isKnmStatusTypeCantBeCarryOut: boolean | undefined;
  isKnmStatusTypeCanceled: boolean | undefined;
  isDictionaryKnoSupervisionStatus: DictionaryStatusesEnum | undefined;
  knmPlanStatus: ErknmPlanStatusesEnum | undefined;
  knmDataMassCancel: IKnmMassCancel | null | undefined;
  knmDataMassDelete: IKnmMassDelete | null | undefined;
  isTest: boolean | null | undefined;
  resigningRequired: boolean;
  settings: IAdminSetting[];
  knmPlanSigned: IKnmAttachment | null | undefined;
  knmPlan: IKnmPlan | null;
  isSignedHistoryChangesExist: number;
}

const KnmHeaderWithoutStore = ({
  erpId,
  isInitialData,
  isErpStatusDeleted,
  isErpStatusDisapproved,
  isErpStatusNeedDoOverAgain,
  isErpStatusSyspApprove,
  knmData,
  isKnmDeleted,
  isProsecutorOrSuperProsecutor,
  isReasonsImpossibility,
  isSupervisor,
  knmCreated,
  knmCreatedBy,
  knmCreationDate,
  knmDataErknmApproveApproved,
  knmSystemType,
  knmUpdated,
  knmUpdatedBy,
  planId,
  publishedStatus,
  status,
  statusText,
  webNotificationInfos,
  untimelyBasic,
  isKnmStatusTypeCantBeCarryOut,
  isKnmStatusTypeCanceled,
  isDictionaryKnoSupervisionStatus,
  knmDataMassCancel,
  knmDataMassDelete,
  isTest,
  resigningRequired,
  isPm,
  knmPlanStatus,
  values,
  settings,
  knmPlanSigned,
  knmPlan,
  isSignedHistoryChangesExist,
  clearDraftPassportData,
}: IKnmHeaderProps & IKnmHeaderStoreProps) => {
  const dispatch = useDispatch<Dispatch<RootActions>>();
  const isKnmDataExist = !!knmData;
  const isPublishAvailable: boolean = getIsPublishAvailable(
    isErpStatusDeleted,
    isErpStatusDisapproved,
    isErpStatusSyspApprove,
    isErpStatusNeedDoOverAgain,
  );

  const {
    input: { value: isDraft },
  } = useField('draft', { subscription: { value: true } });
  const {
    input: { value: draftSavedAt },
  } = useField('draftSavedAt', { subscription: { value: true } });

  const isLaterThanKnmValidationSetting: boolean = isLaterThanAdminSetting(
    knmCreated,
    settings,
    AdminSettingCodesEnum.KNM_VALIDATION_523_4_1_24_STARTS_FROM,
  );

  const createdInfoText = useMemo(
    () =>
      knmCreated &&
      `Создано${knmCreatedBy ? ` ${knmCreatedBy.fullName} (${knmCreatedBy.username})` : ''} ${formatDate({
        date: knmCreated,
        dateFormat: DATE_FORMAT_LONG_MINUTE_FNS,
        parseFormat: DATE_FORMAT_ISO_FNS,
      })}. `,
    [knmCreated, knmCreatedBy],
  );

  const updatedInfoText = useMemo(
    () =>
      knmUpdated
        ? `Обновлено${knmUpdatedBy ? ` ${knmUpdatedBy.fullName} (${knmUpdatedBy.username})` : ''} ${formatDate({
            date: knmUpdated,
            dateFormat: DATE_FORMAT_LONG_MINUTE_FNS,
            parseFormat: DATE_FORMAT_ISO_FNS,
          })}. `
        : '',
    [knmUpdated, knmUpdatedBy],
  );

  const deletedInfoText = useMemo(
    () =>
      knmUpdated && isKnmDeleted
        ? `Удалено${knmUpdatedBy ? ` ${knmUpdatedBy.fullName} (${knmUpdatedBy.username})` : ''} ${formatDate({
            date: knmUpdated,
            dateFormat: DATE_FORMAT_LONG_MINUTE_FNS,
            parseFormat: DATE_FORMAT_ISO_FNS,
          })}. `
        : '',
    [isKnmDeleted, knmUpdated, knmUpdatedBy],
  );

  const massCancelInfoText = useMemo(
    () =>
      isKnmStatusTypeCanceled && knmDataMassCancel?.cancelled
        ? `Мероприятие отменено в результате массовой отмены ${formatDate({
            date: knmDataMassCancel.cancelled,
            dateFormat: DATE_FORMAT_LONG_MINUTE_FNS,
            parseFormat: DATE_FORMAT_ISO_FNS,
          })}`
        : '',
    [isKnmStatusTypeCanceled, knmDataMassCancel],
  );

  const massDeletedDateTime = useMemo(
    () =>
      knmDataMassDelete &&
      formatDate({
        date: knmDataMassDelete?.deleted,
        dateFormat: DATE_FORMAT_LONG_MINUTE_FNS,
        parseFormat: DATE_FORMAT_ISO_FNS,
      }),
    [knmDataMassDelete],
  );

  const typeTitleText: string = useMemo(() => (knmSystemType ? exportKnmTypeEventFormNamesMap[knmSystemType] : ''), [
    knmSystemType,
  ]);

  const backUrl: string | null = useMemo(() => {
    const params = new URLSearchParams(window.location.search);

    return params.get('backUrl');
  }, []);

  const headerAttributes = {
    ...(isKnmDeleted && status?.code !== KnmErknmStatusCodesEnum.TYPE_CANT_BE_CARRY_OUT && { 'data-danger': true }),
    ...(isKnmStatusTypeCanceled && knmDataMassCancel && { 'data-danger': true }),
  };

  const [isKnmSignButtonHover, setIsKnmSignButtonHover] = useState(false);

  const handleMouseOverKnmSignButton = useCallback(() => {
    setIsKnmSignButtonHover(true);
  }, [setIsKnmSignButtonHover]);

  const handleMouseOutKnmSignButton = useCallback(() => {
    setIsKnmSignButtonHover(false);
  }, [setIsKnmSignButtonHover]);

  const restoreAutosaved = useCallback(() => {
    if (knmData) {
      dispatch(knmDraftDelete(knmData.id, clearDraftPassportData, true));
    }
  }, [knmData, clearDraftPassportData]);

  /**
   * Отображение сообщения о неутвержденном плане
   */
  const knmPlanStatusNotApprovedMessage = useMemo(() => {
    if (knmPlanStatus !== ErknmPlanStatusesEnum.APPROVED && values?.typeErknm?.value === 'PP') {
      return (
        <div className={styles.KnmPlanStatusNotApprovedMessage}>
          <span>План не утвержден, проведение КНМ невозможно!</span>
        </div>
      );
    }

    return null;
  }, [knmPlanStatus, values]);

  /**
   * Отображение сообщения о неподписанном плане
   */
  const knmPlanStatusNotSingleMessage = useMemo(() => {
    if (knmPlan == null || values?.typeErknm?.value !== 'PP') {
      return;
    }

    if ((!knmPlanSigned || !knmPlanSigned.signed) && !isPm && isSignedHistoryChangesExist) {
      return (
        <div className={styles.KnmPlanStatusNotApprovedMessage}>
          <span>{PLAN_NO_SIGN_NOTIFICATION_ERROR}</span>
        </div>
      );
    }

    return null;
  }, [knmPlan, knmPlanSigned, values]);

  return (
    <div className={styles.Header} {...headerAttributes}>
      <div className={styles.HeaderContent}>
        <Link
          className={styles.BackButton}
          to={backUrl || (isInitialData && planId ? ROUTE_PLAN_BY_ID(planId) : ROUTE_KNM_LIST)}
        >
          <span className={styles.BackButtonIcon} />
        </Link>
        <div className={styles.TitleBlock}>
          <h3 className={styles.Title}>
            {isTest && <span className={styles.TestUserWrapper}>ТЕСТ</span>}
            {erpId ? `${typeTitleText} ${erpId}${planId ? ` / ${planId}` : ''} ` : `${typeTitleText} `}
          </h3>
          {(!isKnmDataExist || knmCreationDate || !erpId) && (
            <small className={styles.Date}>
              {`от ${
                knmCreationDate
                  ? formatDateLocale({
                      date: knmCreationDate,
                      dateFormat: DATE_FORMAT_LONG_MINUTE_FNS,
                      parseFormat: DATE_FORMAT_ISO_FNS,
                    })
                  : getFormatedClientTime(DATE_FORMAT_LONG_MINUTE_FNS)
              }`}
            </small>
          )}
          {statusText && (
            <>
              <span>&nbsp;</span>
              <span className={styles.Status}>
                {knmSystemType === KnmSystemTypesEnum.ERP
                  ? getNewMappedStatus(statusText, isReasonsImpossibility)
                  : statusText}
              </span>
              {knmSystemType === KnmSystemTypesEnum.ERKNM && <ErknmStatusHint isHover={isKnmSignButtonHover} />}
              {knmSystemType === KnmSystemTypesEnum.PM && <PmStatusHint isHover={isKnmSignButtonHover} />}
              {knmSystemType === KnmSystemTypesEnum.ERKNM &&
                status?.code === KnmErknmStatusCodesEnum.APPROVING &&
                knmDataErknmApproveApproved &&
                webNotificationInfos?.find(
                  item => item.webNotificationType === KnmWebNotificationTypesEnum.VP_AGREEMENT,
                ) && (
                  <div className={styles.StatusAdditionalInfo}>
                    Ожидается подтверждение о согласовании от руководства органа прокуратуры
                  </div>
                )}
            </>
          )}
          <div className={styles.PublishAndErrorIconWrapper}>
            {(knmSystemType === KnmSystemTypesEnum.ERP ? isLaterThanKnmValidationSetting : true) && (
              <div className={styles.PublishedStatus}>
                <span>Статус публикации: &nbsp;</span>
                <span className={styles.Status}>
                  {publishedStatus ? publishedStatusesCodesNamesMap[publishedStatus] : 'Не опубликовано'}
                </span>
              </div>
            )}
            <ErrorsIcon className={styles.Errors} autoHidingTooltip="onHeaderStickOn" />
            {untimelyBasic && isProsecutorOrSuperProsecutor && (
              <ErrorsIconForUntimelyBasic className={styles.Errors} autoHidingTooltip="onHeaderStickOn" />
            )}
          </div>
        </div>
        <KnmHeaderButtons
          className={styles.Buttons}
          isSelfHidden
          location="form"
          onMouseOverKnmSignButton={handleMouseOverKnmSignButton}
          onMouseOutKnmSignButton={handleMouseOutKnmSignButton}
        />
      </div>
      {knmPlanStatusNotApprovedMessage}
      {knmPlanStatusNotSingleMessage}
      {resigningRequired && (
        <div className={styles.InfoBlockResigned}>
          <span>Изменения не считаются внесенными в ЕРКНМ, пока не переподписан паспорт.</span>
          <span>
            Для просмотра предыдущей подписанной редакции паспорта необходимо перейти в раздел «Сведения о подписании
            {isPm ? '' : ' КНМ'}»
          </span>
        </div>
      )}
      {isKnmDeleted && knmDataMassDelete && (
        <div className={styles.MassDeleteBlock}>
          <span>
            Мероприятие удалено в результате массового удаления группы №{knmDataMassDelete.groupId}{' '}
            {massDeletedDateTime} по основанию «{knmDataMassDelete.reason.name}»
          </span>
        </div>
      )}
      {(createdInfoText || updatedInfoText || deletedInfoText) && (
        <div className={styles.InfoBlock}>
          <div className={styles.ActionInfoWrapper}>
            {massCancelInfoText && (
              <div className={cn(styles.ActionInfo, styles.MassCancelInfo)}>{massCancelInfoText}</div>
            )}
            <div className={styles.ActionInfo}>
              {createdInfoText}
              {updatedInfoText}
              {deletedInfoText}
            </div>
            {isDraft && (
              <div className={styles.AutoSaveWrapper}>
                <span>
                  Сохранено автоматически{' '}
                  {convertInitialKnmDateToFormDate(draftSavedAt || '', DATE_FORMAT_LONG_MINUTE_FNS)}
                </span>
                <span className={styles.AutoSaveCancelButton} onClick={restoreAutosaved}>
                  Отменить
                </span>
              </div>
            )}
          </div>
          {(isProsecutorOrSuperProsecutor || isSupervisor) &&
            !isPublishAvailable &&
            (!publishedStatus ||
              publishedStatus === KnmPublishStatusesEnum.UNPUBLISHED ||
              publishedStatus === KnmPublishStatusesEnum.ASK_TO_UNPUBLISH) && (
              <p className={styles.PublishWarning}>{`Публикация ${typeTitleText} в Открытую часть в статусе "${
                knmSystemType === KnmSystemTypesEnum.ERP && status?.name
                  ? getNewMappedStatus(status.name, isReasonsImpossibility)
                  : status?.name
              }" невозможна.`}</p>
            )}
        </div>
      )}
      {isKnmStatusTypeCantBeCarryOut && isDictionaryKnoSupervisionStatus === DictionaryStatusesEnum.FAILED && (
        <div className={styles.InfoBlock}>
          <p className={styles.isKnmStatusTypeCantBeCarryOutError}>
            Для возобновления указанного мероприятия необходимо перевести карточку вида контроля в ЕРВК в статус
            «Опубликовано»
          </p>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state: IRootState): IKnmHeaderStoreProps => ({
  isProsecutorOrSuperProsecutor: getUserRoleIsProsecutorOrSuperProsecutor(state),
  isSupervisor: getUserRoleIsSupervisor(state),
  publishedStatus: getKnmPublishedStatus(state),
  status: getKnmStatus(state),
  statusText: getKnmStatusText(state),
  isErpStatusDeleted: getKnmIsErpStatusDeleted(state),
  isErpStatusDisapproved: getKnmIsErpStatusDisapproved(state),
  isErpStatusSyspApprove: getKnmIsErpStatusSyspApprove(state),
  isErpStatusNeedDoOverAgain: getKnmIsErpStatusNeedDoOverAgain(state),
  isInitialData: getKnmIsInitialData(state),
  knmSystemType: getKnmSystemType(state),
  isReasonsImpossibility: getKnmHasReasonsImpossibility(state),
  erpId: getKnmDataErpId(state),
  knmCreated: getKnmDataCreated(state),
  knmCreatedBy: getKnmDataCreatedBy(state),
  knmCreationDate: getKnmDataCreationDate(state),
  isKnmDeleted: getKnmDataDeleted(state),
  knmUpdated: getKnmDataUpdated(state),
  knmUpdatedBy: getKnmDataUpdatedBy(state),
  planId: getKnmDataPlanId(state),
  untimelyBasic: getKnmDataErknmUntimelyBasic(state),
  knmDataErknmApproveApproved: getKnmDataErknmApproveApproved(state),
  webNotificationInfos: getKnmDataErknmWebNotificationInfos(state),
  isKnmStatusTypeCantBeCarryOut: getKnmIsErknmStatusTypeCantBeCarryOut(state),
  isKnmStatusTypeCanceled: getKnmIsErknmStatusTypeCanceled(state),
  isDictionaryKnoSupervisionStatus: getDictionaryKnoSupervisionStatus(state),
  knmPlanStatus: getPlanListPlanErknmStatus(state),
  isTest: getKnmDataIsTest(state),
  resigningRequired: getKnmDataResigningRequired(state),
  knmData: getKnmData(state),
  knmDataMassCancel: getKnmDataMassCancel(state),
  settings: getAdminFetchSettings(state),
  knmDataMassDelete: getKnmDataMassDelete(state),
  knmPlanSigned: getPlanSigned(state),
  knmPlan: getPlanListPlan(state),
  isSignedHistoryChangesExist: getPlanSignedHistoryChanges(state).length,
});

export const KnmHeader = connect(mapStateToProps)(KnmHeaderWithoutStore);
